/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2026 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

const server = '';

const config = {
    title: 'SmartWall Service Portal - ',
    version: '3.3.0.0021',
    copyrightYear: `2026`,
    roles: {
        supportUser: 'ROLE_SUPPORT_USER',
        mspAdmin: 'ROLE_MSP_ADMINISTRATOR',
        mspUser: 'ROLE_MSP_USER',
        tenantAdmin: 'ROLE_TENANT_ADMINISTRATOR',
        tenantUser: 'ROLE_TENANT_USER'
    },
    roleTitles: {
        supportUser: 'Support User',
        mspAdmin: 'MSP Administrator',
        mspUser: 'MSP User',
        tenantAdmin: 'Tenant Administrator',
        tenantUser: 'Tenant User'
    },
    apis: {
        login: '/auth',
        logout: '/auth/log_out',
        aaa: '/api/aaa',
        themeConfiguration: '/api/theme/themeConfiguration',
        pageTitle: '/api/theme/pageTitle',
        tokenRefresh: '/refresh',
        userBy: '/api/users/search/findByUsername',
        topAttackedTenants: '/api/get_top_attacked_tenants',
        topAttackedProspects: '/api/get_top_attacked_prospects',
        topAttackedIp: '/api/get_top_attacked_ip',
        trafficStatus: '/api/get_site_traffic',
        diagTrafficStatus: '/api/get_diag_site_traffic',
        tenants: '/api/tenants',
        prospects: '/api/prospects',
        attacks: '/api/get_recent_attacks',
        users: '/api/users',
        usageStats: '/api/usageStats',
        exportUsageStats: '/api/usageStats/export',
        roles: '/api/roles',
        countries: '/api/countries',
        timezones: '/api/timezones',
        servicePolicies: '/api/service-policy',
        unassignedAssets: '/api/unassigned-assets',
        assets: '/api/assets',
        dismissAssetReconciliationWarning: 'api/assets/dismiss_asset_reconciliation_warning',
        reconcileAssignedAsset: 'api/assets/reconcile_assigned_asset',
        reconcileAllAssignedAssets: 'api/assets/reconcile_all_assigned_assets',
        getAssignedAssets: '/api/assets/get_assigned_assets',
        addAssignedAsset: '/api/assets/add_assigned_asset',
        updateAssignedAsset: '/api/assets/update_assigned_asset',
        deleteAssignedAsset: '/api/assets/delete_assigned_asset',
        getNamedAssets: '/api/assets/get_named_assets',
        addNamedAsset: '/api/assets/add_named_asset',
        updateNamedAsset: '/api/assets/update_named_asset',
        deleteNamedAsset: '/api/assets/delete_named_asset',
        searchAssets: '/api/assets/search_assets',
        assetGroups: '/api/asset-groups',
        addAssetGroup: '/api/assetGroups',
        auditLogs: '/api/auditLog',
        exportAuditLogs: '/api/auditLog/export',
        termsOfService: '/api/theme/serviceTerm',
        brandingFlag: '/api/theme/getBrandingFlag',
        themeReset: '/api/theme/reset',
        dipTraffic: '/api/get_dip_traffic',
        dipTopN: '/api/attack-top-n',
        theme: 'api/theme',
        changePassword: '/api/users/updatePassword',
        passwordValidation: '/api/users/password-validation',
        license: '/api/license',
        systemUuid: '/api/license/system_uuid',
        sendPasswordResetEmail: '/api/users/sendPasswordResetEmail',
        validatePasswordResetToken: '/api/users/validatePasswordResetToken',
        resetPassword: '/api/users/resetPassword',
        checkToken: '/api/users/checkToken',
        sampleTenants: '/api/sample/tenants',
        sampleProspects: 'api/sample/prospects',
        sampleTenantAssets: '/api/sample/tenant-assets',
        sampleProspectAssets: '/api/sample/prospect-assets',
        sampleUsers: '/api/sample/users',
        exportTenants: '/api/export/tenants',
        exportTenantAssets: '/api/export/tenant-assets',
        exportProspects: '/api/export/prospects',
        exportProspectAssets: '/api/export/prospect-assets',
        exportUsers: '/api/export/users',
        exportTenantUsers: '/api/export/tenant-users',
        importTenantAssets: '/api/import/tenant-assets',
        importProspectAssets:  '/api/import/prospect-assets',
        importTenants: '/api/import/tenants',
        importProspects: '/api/import/prospects',
        importUsers: '/api/import/users',
        importTenantUsers: '/api/import/tenant-users',
        tenantUserConfig: '/api/user_config',
        config: '/api/configs',
        tenantConfig: '/api/tenantConfigs',
        alertPlaceholders: '/api/alert/placeholders',
        alertTemplates: '/api/alert/templates',
        attackFilters: '/api/attack-filters',
        reports: '/api/scheduledReports',
        reportConfig: '/api/scheduledReports/config',
        userReports: '/api/scheduledReports/user',
        allReports: '/api/scheduledReports/all',
        generateReport: '/api/scheduledReports/generate',
        reportsPlaceholders: '/api/scheduledReports/place_holders',
        testReportEmail :  '/api/diagnostic/test-report',
        testPolicyEmail : '/api/diagnostic/test-alert',
        getLdapAttributes: '/api/ldap-attribute/1',
        ldapServers: '/api/ldap-server',
        ldapSync: '/api/ldap-schedule/1',
        ldapInfo: '/api/ldap/sync-info',
        ldapSyncNow: '/api/ldap/sync-now',
        getMappings: '/api/ldap-group-mapping',
        requestDump: `${server}/api/dump/create`,
        checkDumpStatus: `${server}/api/dump/check`,
        downloadDump: `${server}/api/dump/download`,
        diagConfig: `/api/dump/config`,
        ldapLastSyncInfo: `${server}/api/ldap-status/search/latest`,
        unlockUser: `${server}/api/users/unlockUser`,
        broadcastMail: `${server}/api/users/broadcastMail`,
        testBroadcastEmail: `${server}/api/diagnostic/test-broadcast-email`,
        emailSettings: `${server}/api/config/email-settings`,
        requestSystemReboot: `${server}/api/sspservices/reboot`,
        emailHistory: `${server}/api/email-history`,
        emailServiceEnabled: `${server}/api/config/emailServiceEnabled`,
        https: `${server}/api/https-certificate`,
        generateToken: `${server}/api/users/generateToken`,
        emailPasswordToken: `${server}/api/users/emailPasswordToken`,
        snapshot: `${server}/api/snapshot`,
        upgradePackage: `${server}/api/upgradePackage`,
        remoteMitigations: `${server}/api/remote-mitigation`,
        ipIntelligence: `${server}/api/ip-intelligence`,
        webhook: `${server}/api/webhooks`,
        webhookTemplates: `/api/webhook-templates`,
        httpProxy: `${server}/api/config/proxy-settings`,
        webhooksEnabled: '/api/alert/webhooks-enabled',
        favicon: '/api/theme/faviconImage',
        emailTemplates: '/api/email-templates',
        customTenantFieldDefinitions: `/api/custom-tenant-fields`,
        apiTokens: `/api/api-tokens`,
        portalFeedHosts: `/api/swa-hosts`,
        ssoConfig: `/api/sso-config`,
        saml2Config: `/api/saml2-config`,
        saml2AvailableAttributeMappings: `/api/saml2-config/available-attribute-mappings`,
        saml2AvailableTenantMappings: `/api/saml2-config/available-tenant-mappings`,
        healthIssues: `/api/health-issues`,
        healthIssuesChangelog: `/api/health-issues/changelog`,
        healthIssuesChangelogExport: `/api/health-issues/changelog/export`,
        ssoDisableTenantUserCreation: `/api/sso-config/tenant-user-creation`,
        ssoFailureHistory: `/api/sso-config/failure-history`,
        emailNotifications: `/api/email-notifications`,
        loggerConfig: `/api/logger-config`,
        syslogStatistics: `/api/syslog-statistics`,
        systemPerformance: `/api/performance/system`,
        applicationPerformance: `/api/performance/application`,
        diskPerformance: `/api/performance/disk`,
        dbBloatMonitoring: `/api/performance/db/bloat`,
        dbIndexMonitoring: `/api/performance/db/index`,
        tenantUserGuide: `/api/documents/tenant-user-guide`,
        sqlQuery: `/api/diagnostic/sql-query`,
        systemLogs: `/api/system-logs`,
        applicationProperties: `/api/application-properties`,
        dataSummarization: `/api/data-management/summarization`,
        dataRetention: `/api/data-management/retention`,
        dataMigration: `/api/data-management/migration`,
        databaseConfig: `/api/database-properties`,
        externalUrl: `/api/configs/external-url`,
        prospectDiscoverySearch: `/api/prospect-discovery/search`,
        prospectDiscoveryUserConfig: '/api/prospect-discovery-user-config'

    },
    menu: [
        { title: 'Overview', path: '/overview', homepath: true, icon: 'icon-dashboard_icon', auth: ['supportUser', 'mspAdmin', 'mspUser', 'tenantAdmin', 'tenantUser'] },
        { title: 'Analysis', path: '/analysis', icon: 'icon-anslys_icon', auth: ['supportUser', 'mspAdmin', 'mspUser', 'tenantAdmin', 'tenantUser'] },
        { title: 'Tenants', path: '/tenants', icon: 'icon-tenants_icon', auth: ['supportUser', 'mspAdmin', 'mspUser'] },
        { title: 'Prospect Tenants', path: '/prospects', icon: 'icon-profiles_icon', auth: ['supportUser', 'mspAdmin', 'mspUser'] },
        { title: 'Assets', path: '/assets', icon: 'icon-assets_icon', auth: ['tenantAdmin', 'tenantUser'] }
    ],
    attackStatus: {
        'end': { icon: 'icon-complete_icon', title: 'Completed' },
        'start': { icon: 'icon-attack_icon', title: 'Start' },
        'ongoing': {icon: 'icon-attack_icon', title: 'Ongoing'}
    },
    tenantAttackStatus: {
        'enabled': {icon: 'icon-complete_icon', title: 'enabled'},
        'disabled': {icon: 'icon-disabled_icon', title: 'disabled'},
        'attack': {icon: 'icon-attack_icon', title: 'attack'}
    },
    faviconDimensions: {
        D_16X16: 'D_16X16',
        D_32X32: 'D_32X32',
    },
    healthRefreshRateInSeconds: 60
};

export { config };
